import React, { Component } from "react";
import DownloadResults from "./DownloadResults";

class PDFReceipt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rawText: [],
      summaryData: [],
      itemsData: [],
      messages: {
        text: (
          <div className="no-analysis">
            <p>No text was found</p>
          </div>
        ),
        forms: (
          <div className="no-analysis">
            <p>FORM Analysis is Not Enabled.</p>
            <p>If Image contains a FORM : Enable Checkbox and Re-Upload Image</p>
          </div>
        ),
        tables: (
          <div className="no-analysis">
            <p>TABLE Analysis is Not Enabled.</p>
            <p>If Image contains a TABLE : Enable Checkbox and Re-Upload Image</p>
          </div>
        ),
        receiptSummary: (
          <div className="no-analysis">
            <p>Receipt Analysis is Not Enabled.</p>
            <p>If Image contains a Receipt : Enable Checkbox and Re-Upload Image</p>
          </div>
        ),
        receiptItems: (
          <div className="no-analysis">
            <p>Receipt Analysis is Not Enabled.</p>
            <p>If Image contains a Receipt : Enable Checkbox and Re-Upload Image</p>
          </div>
        ),
      },
      summaryPair: '',
      itemsPair: '',
      formsPair: '',
      tablesPair: '',
      rawJson: [],
    };
  }

  componentDidMount() {
    this.processPDFReceipt(this.props.data);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.processPDFReceipt(this.props.data);
    }
  }

  processPDFReceipt = (data) => {
    let parsedData = [];
    if (typeof data === "string") {
        try {
            parsedData = JSON.parse(data);
        } catch (err) {
            console.error("Failed to parse data:", err);
            parsedData = [];
        }
    } else if (Array.isArray(data)) {
        parsedData = data;
    }

    this.setState({ rawJson: parsedData });

    let response = parsedData;

    let rawText = [];
    let summaryData = [];
    let itemsData = [];
    let messages = { ...this.state.messages };
    let summaryPair = '';
    let itemsPair = '';

    if (!response || response.length === 0) {
      messages.text = (
        <div className="no-analysis">
          <p>No text was found</p>
        </div>
      );
      messages.forms = (
        <div className="no-analysis">
          <p>No forms was found</p>
        </div>
      );
      messages.tables = (
        <div className="no-analysis">
          <p>No tables was found</p>
        </div>
      );
      messages.receiptSummary = (
        <div className="no-analysis">
          <p>No receipts was found</p>
        </div>
      );
      messages.receiptItems = (
        <div className="no-analysis">
          <p>No items was found</p>
        </div>
      );

      this.setState({ rawText, summaryData, itemsData, messages });
      return;
    }

    response.forEach((receiptArr, i) => {
        rawText.push([]);

        receiptArr.forEach((receipt) => {
            if (receipt.SummaryFields) {
                receipt.SummaryFields.forEach((field) => {
                    if (field.LabelDetection) {
                        rawText[i].push(field.LabelDetection.Text);
                    }
                    if (field.ValueDetection) {
                        rawText[i].push(field.ValueDetection.Text);
                    }

                    if (field.Type.Text === "VENDOR_NAME") {
                        summaryData.push({ key: "VENDOR_NAME", value: field.ValueDetection?.Text || "" });

                        summaryPair += `VENDOR_NAME,${field.ValueDetection.Text}\n`;
                        summaryPair += '\n';
                    } else if (field.LabelDetection && field.ValueDetection) {
                        summaryData.push({ key: field.LabelDetection.Text, value: field.ValueDetection.Text });

                        summaryPair +=  field.LabelDetection.Text + "," + field.ValueDetection.Text;
                        summaryPair += '\n';
                    }
                });
            }

            const lineItems = receipt.LineItemGroups?.[0]?.LineItems || [];
            lineItems.forEach((item) => {
                item.LineItemExpenseFields.forEach((expField) => {
                    if (expField.Type.Text === "EXPENSE_ROW") {
                        rawText[i].push(expField.ValueDetection.Text);
                    }
                });

                if (item.LineItemExpenseFields.length >= 2) {
                    itemsData.push({
                        item: item.LineItemExpenseFields[0]?.ValueDetection.Text || "",
                        price: item.LineItemExpenseFields[1]?.ValueDetection.Text || "",
                    });

                    itemsPair +=  item.LineItemExpenseFields[0].ValueDetection.Text + "," + item.LineItemExpenseFields[1].ValueDetection.Text;
                    itemsPair += '\n';
                }
            });
        });
    });

    // Update messages dynamically
    messages.text = rawText.length === 0 ? (
      <div className="no-analysis">
        <p>No text was found</p>
      </div>
    ) : "";
    messages.receiptSummary = summaryData.length === 0 ? (
      <div className="no-analysis">
        <p>No receipts was found</p>
      </div>
    ) : "";
    messages.receiptItems = itemsData.length === 0 ? (
      <div className="no-analysis">
        <p>No items was found</p>
      </div>
    ) : "";

    this.setState({ rawText, summaryData, itemsData, messages, summaryPair, itemsPair });
  };

  render() {
    const { rawText, summaryData, itemsData, messages } = this.state;
    const { type } = this.props;

    return (
      <>
        {type === "text" ? (
          <div id="raw-text">
            {rawText.length > 0
              ? rawText.map((lineArr, i) =>
                  lineArr.map((text, j) => (
                    <div key={`${i}-${j}`} className="text inline-text">
                      {text}
                    </div>
                  ))
                )
              : messages.text}
          </div>
        ) : type === "form" ? (
          <div id="forms">{messages.forms}</div>
        ) : type === "table" ? (
          <div id="tables">{messages.tables}</div>
        ) : type === "receiptSummary" ? (
          <div id="receipt-summary">
            {messages.receiptSummary && <div>{messages.receiptSummary}</div>}
            {summaryData.length > 0 && (
              <table className="table table-striped table-hover">
                <thead>
                  <tr>
                    <th>Key</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  {summaryData.map((row, i) => (
                    <tr key={i}>
                      <td>{row.key}</td>
                      <td>{row.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        ) : type === "receiptItems" ? (
          <div id="receipt-items">
            {messages.receiptItems && <div>{messages.receiptItems}</div>}
            {itemsData.length > 0 && (
              <table className="table table-striped table-hover">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Price</th>
                  </tr>
                </thead>
                <tbody>
                  {itemsData.map((row, i) => (
                    <tr key={i}>
                      <td>{row.item}</td>
                      <td>{row.price}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        ) : (
          <></>
        )}
        <DownloadResults
            rawText={this.state.rawText}
            rawJson={this.state.rawJson}
            forms={this.state.formsPair}
            tables={this.state.tablesPair}
            items={this.state.itemsPair}
            summary={this.state.summaryPair}
        />
      </>
    );
  }
}

export default PDFReceipt;